import { IValidation, ValidationInputType } from "@cak-legacy/generation-core";
import { CustomErrorMessage } from "./ValidationHelper";

export abstract class AbstractValidation<TAllValues = unknown> implements IValidation<TAllValues> {
  constructor(private readonly customErrorMessage?: CustomErrorMessage) {}

  abstract validate: (input: ValidationInputType, allValues?: TAllValues) => boolean;
  abstract key: string;
  abstract defaultMessage: (label: string) => string;

  message = (label: string): string => {
    if (this.customErrorMessage) {
      return this.customErrorMessage(label);
    }

    return this.defaultMessage(label);
  };
}
